import { Role } from './role'

export class App {
    public userApp_Id: string = null;
    public name: string = null;
    public description: string = null;
    public default: boolean = false;
    public imageName: string = null;
    public roles: Role[] = [];
}